import { render, staticRenderFns } from "./ProductDesignFormAcc2.vue?vue&type=template&id=5fb9bc84&"
import script from "./ProductDesignFormAcc2.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormAcc2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports